class Utils {
  buildSearchQueryString(filters: any) {
    let query = '?'
    for (const key in filters) {
      if (
        filters[key] !== null &&
        filters[key] !== undefined &&
        filters[key] !== ''
      ) {
        query += `${key}=${filters[key]}&`
      }
    }
    query = query.substr(0, query.length - 1) // remove any extra '&' symbols
    return query
  }
  removeSpecialChars(str: string): string {
    return str.replace(/[^\x20-\x7E]/g, "");
  }
}

export default new Utils();
